import { Box, MultiSelect, SimpleGrid, Text, TextInput } from "@mantine/core";
// import { IconLock } from "@tabler/icons-react";

interface GeographyMarketsProps {
  formData: {
    headquartersCountry: string;
    headquartersCity: string;
    operatingCountries: string[];
    preferredRegions: string[];
  };
  updateForm: (field: string, value: any) => void;
  countryOptions: { group: string; items: string[] }[] | string[];
  regionOptions: { value: string; label: string }[];
  // isFieldLocked?: (fieldName: string) => boolean;
}

export default function GeographyMarkets({
  formData,
  updateForm,
  countryOptions,
  regionOptions,
  // isFieldLocked = () => false,
}: GeographyMarketsProps) {
  // const lockedTooltip = "This field cannot be edited after verification";

  // Commenting unused code to prevent tsc error
  // Helper to render label with optional lock icon
  // const renderLabel = (label: string, fieldName: string, required = false) => (
  //   <Flex align="center" gap={4}>
  //     <Text fz="sm" fw={500}>
  //       {label}
  //       {required && (
  //         <Text span c="red" fz="lg">
  //           {" "}
  //           *
  //         </Text>
  //       )}
  //     </Text>
  //     {isFieldLocked(fieldName) && (
  //       <Tooltip label={lockedTooltip} withArrow position="top">
  //         <Flex align="center">
  //           <IconLock size={12} color="#9CA3AF" />
  //         </Flex>
  //       </Tooltip>
  //     )}
  //   </Flex>
  // );

  return (
    <Box>
      <Text fz="sm" fw={500} mb="sm">
        Headquarters Location
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mb="md">
        {/* Headquarters Country - LOCKED after verification */}
        {/* <Select
          label={renderLabel("Country", "headquartersCountry", true)}
          placeholder="Select country"
          data={countryOptions}
          value={formData.headquartersCountry}
          onChange={(value) => updateForm("headquartersCountry", value)}
          searchable
          disabled={isFieldLocked("headquartersCountry")}
        /> */}

        {/* Headquarters City - Always editable */}
        <TextInput
          label={
            <Text fz="sm" fw={500}>
              City{" "}
              <Text span c="red" fz="lg">
                *
              </Text>
            </Text>
          }
          placeholder="Enter city"
          value={formData.headquartersCity}
          onChange={(e) => updateForm("headquartersCity", e.currentTarget.value)}
        />
      </SimpleGrid>

      {/* Operating Countries - Always editable */}
      <MultiSelect
        label={
          <Text fz="sm" fw={500}>
            Operating Countries{" "}
            <Text span c="red" fz="lg">
              *
            </Text>
          </Text>
        }
        placeholder="Select countries"
        data={countryOptions}
        value={formData.operatingCountries}
        onChange={(value) => updateForm("operatingCountries", value)}
        searchable
        mb="md"
      />

      {/* Preferred Regions - Always editable */}
      <MultiSelect
        label={
          <Text fz="sm" fw={500}>
            Preferred Collaboration Regions (Optional)
          </Text>
        }
        placeholder="Select regions"
        data={regionOptions}
        value={formData.preferredRegions}
        onChange={(value) => updateForm("preferredRegions", value)}
        searchable
      />
    </Box>
  );
}
